import type { ReactNode } from 'react';
import { Icon } from './Icon.js';
import { Logo } from './Logo.js';

/**
 * The two-column frame behind sign-in and registration.
 *
 * The brand panel is not decoration: it is the only place a first-time visitor
 * is told what this product does, and that shared files are never written to
 * disk - they wait in memory only until they are downloaded.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <main className="auth-page">
      <aside className="auth-aside">
        <span className="brand">
          <Logo size={30} />
        </span>

        <div className="auth-pitch">
          <h2>Talk, share, stay in orbit.</h2>
          <p>
            Team chat with direct and group channels, live presence, and file sharing that never
            touches a disk.
          </p>

          <ul className="auth-points">
            <li>
              <Icon name="shieldCheck" size={18} />
              <span>
                <strong>Files are never written to disk</strong>A shared file waits in server memory
                only until your colleagues download it, then it is gone.
              </span>
            </li>
            <li>
              <Icon name="zap" size={18} />
              <span>
                <strong>Real-time by default</strong>
                Messages, reactions and typing arrive over a single live connection.
              </span>
            </li>
            <li>
              <Icon name="users" size={18} />
              <span>
                <strong>Direct and group channels</strong>
                Find a colleague by name, or open a channel for the whole team.
              </span>
            </li>
          </ul>
        </div>

        <p className="auth-foot">Orbit Sync · self-hosted on your infrastructure</p>
      </aside>

      <div className="auth-main">
        <div className="auth-card">
          <span className="brand auth-card-brand">
            <Logo size={28} />
          </span>
          {children}
        </div>
      </div>
    </main>
  );
}
